import { useEffect, useRef } from "react";

import { Joyride } from "react-joyride";
import { useLocation } from "react-router";

import { useTableStoreByRoute } from "@/stores/useTableStore";

import { ROUTES, useMediaQueries } from "../../shared";
import useTutorialMode from "./hooks/useTutorialMode";
import { useStyles } from "./styles/styles";
import TutorialPortal from "./TutorialPortal";
import { TutorialTooltip } from "./TutorialTooltip";

const TutorialMode = () => {
  const {
    isTutorialActive,
    currentStepGroup,
    isTutorialOpen,
    stepIndex,
    handleTutorialExit
  } = useTutorialMode();

  const location = useLocation();
  const { fromMd, toSm } = useMediaQueries();
  const { resetTableDetails } = useTableStoreByRoute(
    location.pathname as ROUTES
  );

  const { overlayCSS } = useStyles();

  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    handleTutorialExit(location.pathname as ROUTES);
    isTutorialActive && resetTableDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromMd, toSm]);

  useEffect(() => {
    const closeTutorial = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleTutorialExit();
      }
    };
    if (isTutorialOpen) {
      globalThis.addEventListener("keydown", closeTutorial);
    }
    return () => {
      globalThis.removeEventListener("keydown", closeTutorial);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTutorialOpen]);

  const tutorialHighlightElement = isTutorialOpen
    ? currentStepGroup[stepIndex]
    : null;

  return (
    <>
      <Joyride
        continuous
        floatingOptions={{ hideArrow: true }}
        options={{
          scrollOffset: 100,
          overlayClickAction: false,
          dismissKeyAction: false,
          skipBeacon: true,
          skipScroll: true,
          blockTargetInteraction: true,
          zIndex: 10000
        }}
        styles={{
          tooltip: { mixBlendMode: "normal" },
          overlay: overlayCSS as any
        }}
        steps={currentStepGroup}
        stepIndex={stepIndex}
        run={isTutorialOpen}
        tooltipComponent={TutorialTooltip}
      />

      {isTutorialOpen && (
        <TutorialPortal tutorialHighlightElement={tutorialHighlightElement} />
      )}
    </>
  );
};

export default TutorialMode;
